import request from '@api/request'

// 通知列表
export const updateEmployee = params => request.post('/api/punchCard/updateEmployee',  params )
